<template>
  <div>
        <h2>
      Preview Data
    </h2>
    <button  class="btn btnAccent"  @click="goBackToImport">Go Back</button>

    <button class="btn btnAccent ms-3" @click="saveMenuChanges">{{activeHeaderName===''?'Import All Data':'Import "'+ activeHeaderName+'"'}}</button>
    
    <div class="d-flex flex-wrap gap-2 my-3">
          <button
            v-for="header in jobData.result.menu_items"
            :key="header.ItemHeader+'-filter'"
            @click="toggleHeaderFilter(header.ItemHeader)"
            :class="['btn', 'btn-sm', 'rounded-pill', isHeaderActive(header.ItemHeader) ? 'btn-dark text-white' : 'btn-outline-secondary']"
          >
            {{ header.ItemHeader }}
          </button>
        </div>


        <!-- 🔍 Search Bar -->
      <div class="mb-3">
      <h5>Item Search</h5>
      <div class="input-group mb-3" style="max-width: 300px;">
        <span class="input-group-text">
         <i class="ph-bold ph-magnifying-glass"></i>
        </span>
        <input
          type="text"
          class="form-control"
          v-model="searchQuery"
          placeholder="Search by name of item"
        />
      </div>
      </div>


 
    <div v-for="(header,headerIndex) in enrichHeaders" :key="'header_'+headerIndex" class="header-group">
          <label :for="'for_'+header" class=" h3 header-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2">{{header.ItemHeader}} <button class="tooltip-btn " type="button" v-on:click="alertInfo('header')" >
      <span class="question-mark">?</span>
    </button></label>
         <div v-if="header.modifiers.length>0" class="row mt-4">
         <div v-for="(modifier,modIndex) in header.modifiers" :key="'modifier_'+modIndex" class="card m-3" style="width: 18rem;">
          <div class="card-body">
            <h5 class="card-title mt-1 mb-2">Modifier <button class="tooltip-btn " type="button" v-on:click="alertInfo('modifier')" >
      <span class="question-mark">?</span>
    </button></h5>
            <div v-for="(answer,index) in modifier.answer_list" :key="'answer'+index" class="m-2"> 
              <p class="card-text text-muted fs-6">{{answer}}</p>
            </div>
          </div>
         </div>
         </div>
        

        <div class="row mt-4" v-if="header.items.length>0">
          <label :for="'for_'+header" class="h5 subheader-underline form-label text-left w-100 text-start custom-label-height fw-bold mt-3 p-2">Items <button class="tooltip-btn " type="button" v-on:click="alertInfo('item')" >
      <span class="question-mark">?</span>
    </button></label>
         <div v-for="(item,index) in header.items" :key="'item_'+index" class="card m-3" style="width: 18rem;">
          <div class="card-body">
            <h5 class="card-title mt-1">{{item.name}}</h5>
            <p class="card-text text-muted fs-6">${{item.cost}}</p>
            <p class="card-text fixedTextBox">{{item.description==""?"N/A":item.description}}</p>
          </div>
        </div>
        </div>
        
        </div>

  </div>
</template>

<script>

import swal from 'sweetalert';
import MenuJobService from '../../api/menuJob'
export default {
    props: {
      jobData: {
        type: Object, // Define the expected type
      },
      venue_id:{
        type:String
      }
  },
  data() {
    return {
        submitData:[],
        activeHeaderName:'',
        selectedHeader:"",
        searchQuery:"",
        applyVariant:false,
        variantValue:'',
        options: [
      { value: 'header', label: 'Header' },
      { value: 'itemName', label: 'Item Name' },
      { value: 'modifier', label: 'Modifier' },
    ]
    };
  },
  methods: {
    toggleHeaderFilter (id) {
      if (this.activeHeaderName===id) {
        this.activeHeaderName = ''
      } else {
        this.activeHeaderName= id
      }
    },
    isHeaderActive(id) {
      return this.activeHeaderName === id
    },
    selectOption(value) {
      this.variantValue = value;
    },
    alertInfo(info){
    switch(info) {
      case 'header':
        swal("Header Update", 
          "You can import headers one at a time or all at once. After importing, you can update the name, tax details, and location-specific settings in 'Manage Headers'."
        );        
          // code block
        break;
      case 'item':
        swal("Item Updates", 
          "Each item will be available for editing in 'Manage Menu' after import. You can also add pictures at that time."
        );
        // code block
        break;
      case 'modifier':
        swal("Modifier Updates", 
          "If multiple prices are detected, they’ll be split into modifiers, and the lowest price will be shown on the item. You can update or delete modifiers later in the 'Manage Menu' screen."
        );
        // code block
        break;
      default:
                swal("Apply Variant","Extra data used to filter/create menu")

        // code block
    }
    },
    goBackToImport(){
        this.$emit("goBack")
    },
    selectHeader(header){
        this.selectedHeader=header
    },
    saveMenuChanges() {
      // Save all changes to the menu (replace with actual API call)
      swal({
        title: `Are you sure you want to import ${this.activeHeaderName===''? 'all headers?':this.activeHeaderName +' header?'} `,
        text: 'This will add all related items and modifiers.',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Confirm',
        },
        closeOnClickOutside: false,
      })
        .then((value) => {
            if(value){
            const body = {
              headerName:this.activeHeaderName,
             id:this.jobData._id,
             venueID: this.venue_id
            }
            MenuJobService.createMenu(body).then(()=>{
              swal('Save is successful! Refreshing screen').then(()=>{
                window.location.reload()
              })
            })
            }
            });
      console.log('work')
    },
  },
  computed:{
    enrichHeaders() {
      let itemHeaderArray = [];

      // Step 1: Filter headers by activeHeaderName (if any)
      if (this.activeHeaderName === '') {
        itemHeaderArray = this.jobData.result.menu_items;
      } else {
        itemHeaderArray = this.jobData.result.menu_items.filter(
          (data) => this.activeHeaderName === data.ItemHeader
        );
      }

      // Step 2: Map each header and filter its nested items by searchQuery
      return itemHeaderArray.map((header) => {
        const filteredItems = (this.searchQuery === ''
        ? header.items
        : header.items.filter((item) =>
            item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
          )
      ).reduce((acc, current) => {
        const nameKey = current.name.toLowerCase();
        const existing = acc.find(item => item.name.toLowerCase() === nameKey);

        if (!existing || current.cost < existing.cost) {
          // Replace or insert if it's cheaper (or first time)
          const { name, description, variant, cost, include } = current;
          const newItem = { name, description, variant, cost, include };
          // Remove the old one if needed
          acc = acc.filter(item => item.name.toLowerCase() !== nameKey);
          acc.push(newItem);
        }

        return acc;
      }, []);

      const variantSet = new Set();

      header.items.forEach(item => {
        if (item.variant && item.variant.trim() !== '') {
          variantSet.add(item.variant.trim());
        }
      });
      const answer_list = Array.from(variantSet)

      const modifier = {answer_list}



        return {
          ItemHeader: header.ItemHeader,
          items: filteredItems,
          modifiers:answer_list.length>0? [modifier] : []
        };
      });
    },
    firstTenPreview(){
        if(this.selectedHeader!=''){
             var list = this.$props.jobData.result.menu_items.filter(data => data.ItemHeader === this.selectedHeader)
             return list.length>0? list[0].items.limit(10):[]
        }
        return [];
    }
  }
};
</script>

<style scoped>
/* Add your styles here */
.menu-section {
  margin-bottom: 20px;
}

.menu-item {
  margin-bottom: 10px;
}

input {
  margin-left: 10px;
}
</style>